<div class="benefit-content">
  <div class="title">
    {{ "common.benefits" | translate }}
  </div>
  @if (data?.code) {
    <app-benefit
      [code]="data?.code"
      [insuranceType]="data?.insuranceType"
    ></app-benefit>
  }
</div>

@if (productDocumentInterface?.length) {
  <div class="links">
    @for (item of productDocumentInterface; track item) {
      <a
        href=""
        [href]="item.url"
        target="_blank"
        >
        {{ item.name }}
      </a>
    }
  </div>
}
